import React from 'react';
import { Box } from '../../../../base/Box/Box';
import { TwoBoxCardsCardStoryblok } from '../../../../types/storyblok';
import Markup from '../../../../base/Markup/Markup';
import { Type } from '../../../../base/Type/Type';
import Link from '../../../../base/Link/Link';

export const TwoBoxCardsCard = ({
  heading,
  description,
  linkTitle,
  link,
}: TwoBoxCardsCardStoryblok) => {
  if (!heading && !description && !linkTitle && !link) {
    return null;
  }

  return (
    <Box
      as="section"
      className="rounded border p-10"
      insetBkg
      shadow
      border
      overlayOverBkg
    >
      <Box as="div">
        <Box as="div">
          <Type as="h2" className="mb-2 text-h5 uppercase">
            {heading}
          </Type>

          <Markup content={description} className="mb-10 text-p1" />
        </Box>

        <Link href={link} variant="primary">
          {linkTitle}
        </Link>
      </Box>
    </Box>
  );
};

export default TwoBoxCardsCard;
